<template>
  <div class="log-item-wrap">
    <div class="item-header">
      <div class="list-item">
        <span class="item-label">操作时间：</span>
        <span class="item-value">{{ dataItem.createTimeStr }}</span>
      </div>
      <div class="list-item">
        <span class="item-label">操作人：</span>
        <span class="item-value">{{ dataItem.operator }}</span>
      </div>
      <div class="list-item">
        <span class="item-label">产品名称：</span>
        <span class="item-value">{{ dataItem.appName }}</span>
      </div>
      <div class="list-item">
        <span class="item-label">素材组名称：</span>
        <span class="item-value">{{ dataItem.materialName }}</span>
      </div>
    </div>
    <div class="log-content">
      <span class="log-title">操作记录</span>
      <div class="table-wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            v-for="item of colList"
            :key="item.value"
            :prop="item.value"
            :label="item.label"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row[item.value] === 0"
                :class="['show-text', scope.row[item.value] === 0 ? 'wsc' : '']"
                ><i class="el-icon-minus"></i
              ></span>
              <span
                v-else-if="scope.row[item.value] === 1"
                :class="['show-text', scope.row[item.value] === 1 ? 'ysc' : '']"
                ><i class="el-icon-check"></i
              ></span>
              <span
                v-else-if="scope.row[item.value] === 2"
                :class="['show-text', scope.row[item.value] === 2 ? 'yx' : '']"
                >有效</span
              >

              <span
                v-else-if="scope.row[item.value] === 3"
                :class="['show-text', scope.row[item.value] === 3 ? 'yxpro' : '']"
                >有效+</span
              >
              <span
                v-else-if="scope.row[item.value] === 4"
                :class="['show-text', scope.row[item.value] === 4 ? 'dl' : '']"
                >带量</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span class="mark-title">素材备注：</span>
      <div class="mark-wrap">{{ dataItem.remark }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LogItem",
  props: {
    dataItem: Object,
  },
  data() {
    return {
      colList: [
        { label: "素材综合效果", value: "materialEffect" },
        { label: "FB", value: "FB" },
        { label: "GG", value: "GG" },
        { label: "TT", value: "TT" },
        { label: "unity", value: "unity" },
        { label: "mintegral", value: "mintegral" },
        { label: "今日头条", value: "toutiao" },
        { label: "微信", value: "wechat" },
        { label: "广点通", value: "tencent" },
        { label: "快手", value: "kuaishou" },
      ],
    };
  },
  computed: {
    tableData() {
      if (this.dataItem) {
        const { materialEffect, FB, GG, TT, unity, mintegral, toutiao, wechat, tencent, kuaishou } =
          this.dataItem;
        return [
          {
            materialEffect,
            FB,
            GG,
            TT,
            unity,
            mintegral,
            toutiao,
            wechat,
            tencent,
            kuaishou,
          },
        ];
      } else {
        return [];
      }
    },
  },
};
</script>

<style lang="less" scoped>
.log-item-wrap {
  margin-top: 10px;
  .item-header {
    display: flex;
    padding: 12px 0;
    .list-item {
      flex-shrink: 0;
      margin-right: 45px;
      .item-label {
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
      }
      .item-value {
        color: rgba(0, 0, 0, 1);
        font-size: 14px;
      }
    }
  }
  .log-content {
    border-radius: 4px;
    border: 1px solid rgba(237, 237, 237, 1);
    box-sizing: border-box;
    background: rgba(245, 245, 245, 1);
    padding: 16px 14px;
    .log-title {
      display: inline-block;
      color: rgba(0, 0, 0, 1);
      font-weight: bold;
      font-size: 14px;
      margin-bottom: 12px;
    }
    .mark-title {
      display: inline-block;
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
      margin: 12px 0 10px 0;
    }
    .mark-wrap {
      padding: 12px 16px;
      background-color: rgba(255, 255, 255, 1);
      border-radius: 2px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      box-sizing: border-box;
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
    }
    .table-wrap {
      .show-text {
        width: 48px;
        height: 24px;
        font-size: 14px;
        text-align: center;
        padding: 4px 8px;
        border-radius: 4px;
        &.wsc {
          font-size: 18px;
        }
        &.ysc {
          color: rgba(24, 144, 255, 1);
          font-size: 20px;
        }
        &.yx {
          background-color: rgba(255, 237, 141, 1);
          color: rgba(170, 105, 8, 1);
        }
        &.yxpro {
          background-color: rgba(143, 235, 207, 1);
          color: rgba(12, 131, 95, 1);
        }
        &.dl {
          background-color: rgba(172, 131, 246, 1);
          color: white;
        }
      }
    }
  }
}
</style>
